import { defineStore } from 'pinia'
import { ref } from 'vue'
import { ProfileService } from '@/services/profile.service'
import NotificationMessageService from '@/services/notificationmessage.service'
import { User } from '@/entities/user'

const service = new ProfileService()

export const useProfileStore = defineStore('profile', () => {
  // State
  const profile = ref<Partial<User> | null>(null)

  // Getter
  function getProfile(): Partial<User> | null {
    return profile.value as Partial<User> | null
  }

  function setProfile(data: Partial<User>) {
    if (!profile.value) {
      profile.value = data as User
    } else {
      profile.value = { ...profile.value, ...data }
    }
  }

  // Action
  async function fetchProfile(userId: string) {
    try {
      const result = await service.getProfile(userId)
      if (result) {
        profile.value = result
      }
    } catch (_) {
      NotificationMessageService.showError("Profile data could not be loaded.")
    }
  }

  return {
    // State
    profile,

    // Getters
    getProfile,

    // Actions
    setProfile,
    fetchProfile,
  }
})
